import React, { useEffect, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LockIcon from "@mui/icons-material/Lock";
import {
  Box,
  Typography,
  List,
  ListItem,
  Tooltip,
  Modal,
} from "@mui/material";
import { styled } from "@mui/system";
import { useForm } from "react-hook-form";
import axios from "axios";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Card, Col, Container, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import LinkingForUploadRepAppointmentPage from "./LinkingForUploadRepAppointmentPage";
import { CheckToken } from "../login/AccessToken";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DiagnosticReportsUnderwriter from "../utils/DiagnosticReportsUnderwriter";
import { usePermissions } from "../login/PermissionContext";

const randomId = uuidv4();

function UploadFileForModal({ abhaId, patientId, handleClose, onUploadSuccess }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
    reset,
  } = useForm();

  const [userRole, setUserRole] = useState(sessionStorage.getItem("roleType"));
  const [submitted, setSubmitted] = useState(false);
  const [fileTypes, setFileTypes] = useState([]);
  const [HIPTypes, setHIPTypes] = useState([]);
  const [DataTypes, setDataTypes] = useState([
    "Structured Data",
    "Unstructured Data",
  ]);
  const [care_context_list, setCare_context_list] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [currentPatient, setCurrentPatient] = useState();
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [selectedPatient, setSelectedPatient] = useState();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [fileNameSelected, setFileNameSelected] = useState("");
  const history = useHistory();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const REACT_APP_SUFFIX =
    process.env.REACT_APP_IS_ABDM_CONNECTED_WITH_PROD === "true"
      ? process.env.REACT_APP_SUFFIX_PR
      : process.env.REACT_APP_SUFFIX_SB;
  const [refresh, setRefresh] = useState(false);
  const [copied, setCopied] = useState(false);
  const [selectedRefId, setSelectedRefId] = useState("");
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [aiResponse, setAiResponse] = useState(null);

  const { userInfo } = usePermissions();
  const isAIEnabled = userInfo.ai_enabled;

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: "transparent",
      padding: 0,
      maxWidth: 300,
    },
  });

  const handleCopy = () => {
    if (selectedRefId) {
      navigator.clipboard
        .writeText(selectedRefId)
        .then(() => setCopied(true))
        .catch((err) => console.error("Failed to copy text: ", err));
      setTimeout(() => setCopied(false), 1500);
    }
  };

  const handleRefresh = () => {
    setRefresh(!refresh);
  };

  useEffect(() => {
    if (Token()) {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          { headers: headers }
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });
    }
  }, [authToken]);

  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
    if (
      sessionStorage.getItem("subscriptionType") !== undefined &&
      sessionStorage.getItem("subscriptionType") !== null &&
      sessionStorage.getItem("subscriptionType").includes("Connector/Adaptor")
    ) {
      history.push("/hlthtek-demo");
    }
    setValue("facility_id", sessionStorage.getItem("facility_name"));
  }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    var res = [];
    if (isAIEnabled) {
      res = [
        "Prescription",
        "Quantitative Lab Report (OCR based)",
        "Diagnostic Report",
        "OP Consultation",
        "Discharge Summary",
        "Immunization Record",
        "Health Document",
        "Wellness Record",
      ];
    } else {
      res = [
        "Prescription",
        "Diagnostic Report",
        "OP Consultation",
        "Discharge Summary",
        "Immunization Record",
        "Health Document",
        "Wellness Record",
      ];

    }
    setHIPTypes(res);
  }, [isAIEnabled]);

  const onChangeHIP = () => {
    setFileTypes(["LIPID-PROFILE", "BLOOD-REPORT", "X-Ray", "USG", "CT Scan"]);
  };

  const downloadTemplate = () => {
    //ChangeCursor();
    const mapHiTypes = {
      Prescription: "prescription",
      "Quantitative Lab Report (OCR based)": "diagnostic_report",
      "Diagnostic Report": "diagnostic_report",
      "OP Consultation": "op_consultation",
      "Discharge Summary": "discharge_summary",
      "Immunization Record": "immunization_record",
      "Health Document": "health_document",
      "Wellness Record": "wellness_record",
    };
    if (Token()) {
      // const body = { hi_type: getValues("health_info_type") };
      const selectedType = getValues("health_info_type");

      if (!selectedType) {
        toast.error("Select Health Info type to download the template");
        return;
      }
      if (selectedType === "Health Document") {
        toast.error("Template download not available for 'Health Document'");
        return;
      }

      const mappedType = mapHiTypes[selectedType];
      const body = { hi_type: mappedType };

      if (getValues("health_info_type") === null) {
        toast.error("Select Health Info type to download the template");
      }
      // else if (getValues("file_type") === null) {
      //   toast.error("Select File type to download the template");
      // }
      else {
        axios
          .post(`${REACT_APP_BACKEND_ROUTE_URL}get_hi_type_xlsx_files/`, body, {
            headers: headers,
          })
          // .then((response) => {
          //   var blob = b64toBlob(response.data["body"], "application/zip");
          //   const url = window.URL.createObjectURL(blob, {
          //     type: "application/zip",
          //   });
          //   const link = document.createElement("a");
          //   link.href = url;
          //   link.setAttribute("download", `${getValues("file_type")}.zip`);
          //   document.body.appendChild(link);
          //   link.click();
          //   //ChangeCursor();
          // })

          .then((response) => {
            if (
              response.data.status == "Success" &&
              response.data.message == "Files retrieved successfully"
            ) {
              const { master_xlsx_url, detail_xlsx_url } = response.data;

              // Download Master.xlsx
              const link1 = document.createElement("a");
              link1.href = master_xlsx_url;
              link1.setAttribute("download", "Master.xlsx");
              link1.setAttribute("target", "_blank");
              document.body.appendChild(link1);
              link1.click();
              link1.remove();

              // Download Detail.xlsx
              const link2 = document.createElement("a");
              link2.href = detail_xlsx_url;
              link2.setAttribute("download", "Detail.xlsx");
              link2.setAttribute("target", "_blank");
              document.body.appendChild(link2);
              link2.click();
              link2.remove();
            } else {
              toast.error("error in downloading");
            }
          })
          .catch((err) => {
            console.log(err);
            //ChangeCursor();
          });
      }
    }
  };

  var b64toBlob = function (b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  function formatDate(date) {
    return (
      [
        date.getFullYear(),
        padTo2Digits(date.getMonth() + 1),
        padTo2Digits(date.getDate()),
      ].join("-") +
      "-" +
      [
        padTo2Digits(date.getHours()),
        padTo2Digits(date.getMinutes()),
        padTo2Digits(date.getSeconds()),
      ].join("-")
    );
  }

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    if (Token()) {
      const file = document.querySelector("input[type=file]").files[0];
      if (file !== undefined) {
        const isDiagUnstructured =
          getValues("health_info_type") === "Quantitative Lab Report (OCR based)" &&
          getValues("data_type") === "Unstructured Data";
        // If Quantitative Lab Report (OCR based) + Unstructured, hit AI upload endpoint and show underwriter view
        if (isDiagUnstructured && isAIEnabled) {
          const aiFormData = new FormData();
          aiFormData.append("patient_id", getValues("patient_id"));
          aiFormData.append("document_type", "diagonstic_report");
          aiFormData.append(
            "carecontext_reference_id",
            getValues("carecontext_ref_id")
          );
          aiFormData.append("file", file);
          axios
            .post(
              `${REACT_APP_BACKEND_ROUTE_URL}process_diagnostic_report/`,
              aiFormData,
              {
                headers: headers,
              }
            )
            .then(async (response) => {
              if (response.data.status === "Success") {
                handleRefresh();
                toast.success(
                  "File sent for AI processing. Please follow the status in the Status Table"
                );
                if (onUploadSuccess) await onUploadSuccess();
              } else {
                toast.error(response.data.message);
              }
            })
            .catch((err) => {
              console.log(err);
              toast.error(
                err?.response?.data?.message ||
                err.message ||
                "AI upload failed."
              );
            });

          setSubmitted(true);
          return;
        } else {
          const date_prefix = formatDate(new Date());
          const extension = file.name.split(".").pop();
          const fileName =
            file.name.slice(0, 5) + "-" + date_prefix + "." + extension;

          const mapHiTypes = {
            Prescription: "prescription",
            "Quantitative Lab Report (OCR based)": "diagonstic_report",
            "Diagnostic Report": "diagonstic_report",
            "OP Consultation": "op_consultation",
            "Discharge Summary": "discharge_summary",
            "Immunization Record": "immunization_record",
            "Health Document": "health_document",
            "Wellness Record": "wellness_record",
          };
          const hiType = mapHiTypes[getValues("health_info_type")] || "";
          const data_type = getValues("data_type");
          var bodyFormData = new FormData();
          bodyFormData.append(
            "patientABHA",
            abhaId
              ? getValues("abha_id").endsWith(REACT_APP_SUFFIX)
                ? getValues("abha_id")
                : getValues("abha_id") + REACT_APP_SUFFIX
              : null
          );
          bodyFormData.append("patientID", getValues("patient_id"));
          bodyFormData.append("HIP_ID", getValues("facility_id"));
          const careContextReferenceIDString =
            getValues("carecontext_ref_id") || "";
          const careContextReferenceID =
            careContextReferenceIDString.split("_")[0] || "";
          bodyFormData.append("careContextReferenceID", careContextReferenceID);
          bodyFormData.append("facilityCode", "002347");
          bodyFormData.append("documentType", hiType);
          bodyFormData.append("file", file);
          if (data_type !== undefined && data_type === "Unstructured Data") {
            bodyFormData.append("batch", false);
            bodyFormData.append("structured", false);
          } else {
            bodyFormData.append("batch", true);
            bodyFormData.append("structured", true);
          }

          axios
            .post(
              `${REACT_APP_BACKEND_ROUTE_URL}upload_health_records/`,
              bodyFormData,
              { headers: headers }
            )
            .then(async (response) => {
              if (response.data.status === "Success") {
                toast.success(response.data.message);
                handleRefresh();
                if (onUploadSuccess) await onUploadSuccess();
              } else {
                const message =
                  response.data.message || "An unknown error occurred.";
                if (message.includes("corrupted")) {
                  toast.error(
                    "The Facility documents uploaded are corrupted. Please try with a different document."
                  );
                } else if (message.includes("Virus")) {
                  toast.error(
                    "The Facility documents uploaded has virus. Please try with a different document."
                  );
                } else {
                  toast.error(message);
                }
              }
              if (
                sessionStorage.getItem("subscriptionType") ===
                "ABDM Connector/Adaptor - HIU/HIP" ||
                sessionStorage.getItem("subscriptionType") ===
                "ABDM Connector/Adaptor - HIU" ||
                sessionStorage.getItem("subscriptionType") ===
                "ABDM Connector/Adaptor - HIP"
              ) {
                var requestBody = new FormData();
                requestBody.append("patientID", getValues("patient_id"));
                requestBody.append("HIP_ID", getValues("facility_id"));
                requestBody.append(
                  "careContextReferenceID",
                  careContextReferenceID
                );
                axios
                  .post(
                    `${REACT_APP_BACKEND_ROUTE_URL}fetch_health_records_for_connector/`,
                    requestBody,
                    { headers: headers }
                  )
                  .then((res) => {
                    console.log(res.data);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            })
            .catch((err) => {
              console.log(err);
              toast.error(err.message || "An error occurred during upload.");
            });
        }
      } else {
        toast.error("Please choose a file first!!");
      }
      setSubmitted(true);
    }
  };

  const upload = watch("uploaded_file");
  const abha_id_field =
    watch("abha_id") !== undefined &&
    watch("abha_id") !== null &&
    watch("abha_id") !== "" &&
    (watch("abha_id").endsWith(REACT_APP_SUFFIX)
      ? watch("abha_id")
      : watch("abha_id") + REACT_APP_SUFFIX);
  const patient_id_field = watch("patient_id");
  const facility_id_field = watch("facility_id");
  const isDiagUnstructured =
    watch("health_info_type") === "Quantitative Lab Report (OCR based)" &&
    watch("data_type") === "Unstructured Data";
  const acceptedFileTypes = isDiagUnstructured && isAIEnabled ? ".pdf" : ".zip";

  useEffect(() => {
    if (abhaId) {
      var patientData = patientList.filter(
        (item) => item.abha_id === abha_id_field
      );
      if (patientData !== undefined && patientData.length > 0) {
        setValue("patient_id", patientData[0].patient_id);
        setCurrentPatient(patientData[0]);
      } else {
        setValue("patient_id", patientId || "");
      }
    } else {
      setValue("patient_id", patientId || "");
    }
  }, [abha_id_field, patientList, patientId]);

  useEffect(() => {
    if (care_context_list.length > 0) {
      reset({
        carecontext_ref_id: undefined,
      });
      setCare_context_list([]);
    }
  }, [abha_id_field, patient_id_field, facility_id_field]);

  useEffect(() => {
    if (upload !== undefined && upload.length > 0) {
      setFileNameSelected(upload);
    }
  }, [upload]);

  useEffect(() => {
    if (acceptedFileTypes !== ".pdf" || !upload || upload.length === 0) {
      setPdfPreviewUrl((prev) => {
        if (prev) {
          URL.revokeObjectURL(prev);
        }
        return "";
      });
      setIsPreviewModalOpen(false);
      return;
    }

    const previewUrl = URL.createObjectURL(upload[0]);
    setPdfPreviewUrl((prev) => {
      if (prev) {
        URL.revokeObjectURL(prev);
      }
      return previewUrl;
    });

    return () => {
      URL.revokeObjectURL(previewUrl);
    };
  }, [upload, acceptedFileTypes]);

  const get_care_contexts = () => {
    if (
      getValues("patient_id").length <= 0 &&
      (!abhaId || getValues("abha_id").length <= 0)
    ) {
      toast.error("Please fill either ABHA Address or Patient ID");
    } else if (abhaId && getValues("abha_id").length > 0) {
      var post_data = {};
      if (Token()) {
        post_data.filter_type = "patient_abha";
        post_data.filter_details = {};
        post_data.filter_details.patient_abha = getValues("abha_id").endsWith(
          REACT_APP_SUFFIX
        )
          ? getValues("abha_id")
          : getValues("abha_id") + REACT_APP_SUFFIX;
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}fetch_care_contexts_by_filter/`,
            JSON.stringify(post_data),
            { headers: headers }
          )
          .then((res) => {
            if (res.data.status !== "Failed") {
              if (res.data.care_contenxts.length <= 0) {
                toast.error("No Visit Purpose.");
              }
              setCare_context_list(res.data.care_contenxts);
              setSelectedRefId(
                res.data.care_contenxts.length > 0
                  ? res.data.care_contenxts[0].care_context_reference
                  : null
              );
            } else {
              if (getValues("patient_id").length > 0) {
                fetch_by_patient_id();
              } else {
                toast.error("Visit Purpose Fetch Failed!!");
              }
            }
          });
      }
    } else {
      fetch_by_patient_id();
    }
  };

  const fetch_by_patient_id = () => {
    var post_data = {};
    if (Token()) {
      post_data.filter_type = "patient_id";
      post_data.filter_details = {};
      post_data.filter_details.patient_id = getValues("patient_id");
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}fetch_care_contexts_by_filter/`,
          JSON.stringify(post_data),
          { headers: headers }
        )
        .then((res) => {
          if (res.data.status !== "Failed") {
            if (res.data.care_contenxts.length <= 0) {
              toast.error("No Visit Purpose.");
            }
            setCare_context_list(res.data.care_contenxts);
            setSelectedRefId(
              res.data.care_contenxts.length > 0
                ? res.data.care_contenxts[0].care_context_reference
                : null
            );
          } else {
            toast.error("Visit Purpose Fetch Failed!!");
          }
        });
    }
  };

  const navigate = (e) => {
    history.push(`/${e.target.id}`);
  };

  useEffect(() => {
    setValue("abha_id", abhaId);
  }, [abhaId]);

  useEffect(() => {
    if (abhaId) {
      var patientData = patientList.filter((item) => item.abha_id === abhaId);
      if (patientData !== undefined && patientData.length > 0) {
        setValue("patient_id", patientData[0].patient_id);
      } else {
        setValue("patient_id", patientId || "");
      }
    } else {
      setValue("patient_id", patientId || "");
    }
  }, [patientList, abhaId, patientId]);

  if (aiResponse) {
    return (
      <DiagnosticReportsUnderwriter
        initialData={aiResponse}
        setAiResponse={setAiResponse}
        selectedPatient={selectedPatient}
        handleRefresh={handleRefresh}
      />
    );
  }

  return (
    <>
      <div style={{ marginTop: "11px" }}>
        <div
          className="col-sm-12 col-md-12 col-lg-12"
          style={{ margin: "auto" }}
        >
          {/* <div className="contact-panel mb-50"> */}
          {/* <IconButton
              onClick={handleClose}
              style={{ position: "absolute", top: 0, right: 0 }}
            >
              <CloseIcon />
            </IconButton> */}
          {/* <h1 style={{ textAlign: "center" }}> Upload Report</h1> */}
          {/* <div style={{ marginTop: "2%" }} className="main-title">
              Upload Report
            </div> */}
          <form
            className="contact-panel__form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ABHA Address (Optional)"
                    name="abha_id"
                    disabled
                    {...register("abha_id")}
                  />
                  {errors.abha_id && (
                    <p className="errorMsg">{errors.abha_id.message}</p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Patient ID"
                    name="patient_id"
                    {...register("patient_id", {
                      required: "Patient ID is required.",
                    })}
                    disabled={!!abhaId}
                  />
                  {errors.patient_id && (
                    <p className="errorMsg">{errors.patient_id.message}</p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Facility ID"
                    name="facility_id"
                    {...register("facility_id", {
                      required: "Facility ID is required.",
                    })}
                    disabled
                  />
                  {errors.facility_id && (
                    <p className="errorMsg">{errors.facility_id.message}</p>
                  )}
                </div>
              </div>
              {care_context_list !== undefined &&
                care_context_list.length > 0 ? (
                <>
                  <div className="col-sm-5 col-md-5 col-lg-5">
                    <div className="form-group">
                      <i className="icon-user form-group-icon"></i>
                      <select
                        className="form-control"
                        placeholder="Select Visit Purpose"
                        name="carecontext_ref_id"
                        {...register("carecontext_ref_id", {
                          required: abhaId
                            ? "Consultation type is required."
                            : false,
                        })}
                        style={{ width: "100%" }}
                        onChange={(e) => setSelectedRefId(e.target.value)}
                      >
                        {care_context_list.map((item, index) => (
                          <option
                            key={index}
                            value={item.care_context_reference}
                          >
                            {item.care_context_reference}
                          </option>
                        ))}
                      </select>
                      {errors.carecontext_ref_id && (
                        <p className="errorMsg">
                          {errors.carecontext_ref_id.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div
                    className="col-sm-1 col-md-1 col-lg-1"
                    style={{ margin: "auto" }}
                  >
                    {care_context_list.length > 0 && (
                      <div
                        type="button"
                        onClick={handleCopy}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          margin: "auto",
                          color: copied ? "green" : "black",
                        }}
                      >
                        <ContentCopyIcon />
                        {copied && (
                          <span style={{ marginLeft: "5px" }}>Copied!</span>
                        )}
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <button
                    type="button"
                    onClick={() => get_care_contexts()}
                    className="btn btn__secondary btn__rounded btn__block mt-12"
                  >
                    <span>Get Visit Purpose</span>{" "}
                    <i className="icon-arrow-right"></i>
                  </button>
                </div>
              )}
              {/* <div className="col-sm-4 col-md-4 col-lg-4">
                <div className="form-group" onChange={() => onChangeHIP()}>
                  <label>Health Information Type</label>
                  {HIPTypes.map((item, index) => (
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        placeholder="Select Health Information Type"
                        value={item}
                        name="health_info_type"
                        {...register("health_info_type", {
                          required: "Health Info Type is required.",
                        })}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexRadioDefault2"
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div> */}

              <div className="col-sm-12">
                <div className="form-group" onChange={() => onChangeHIP()}>
                  <label className="d-block mb-2">
                    Health Information Type
                  </label>
                  <div className="row">
                    {HIPTypes.map((item, index) => (
                      <div key={index} className="col-6 col-md-4 col-lg-3">
                        <div className="form-check">
                          <input
                            style={{ marginTop: "0.3rem" }}
                            type="radio"
                            className="form-check-input"
                            id={`hip-${index}`}
                            value={item}
                            name="health_info_type"
                            {...register("health_info_type", {
                              required: "Health Info Type is required.",
                            })}
                          />
                          <label
                            style={{ fontWeight: 500, fontSize: "12px" }}
                            className="form-check-label"
                            htmlFor={`hip-${index}`}
                          >
                            {item}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* <div className="col-sm-5 col-md-4 col-lg-4">
                <button
                  type="button"
                  onClick={() => downloadTemplate()}
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                >
                  <span>Download Template</span>{" "}
                  <i className="icon-arrow-right"></i>
                </button>
                <div className="contact-result"></div>
              </div> */}
              <div className="col-sm-12 col-md-12 col-lg-12">
                <button
                  type="button"
                  onClick={() => downloadTemplate()}
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10 mb-10"
                >
                  <span>Download Template</span>{" "}
                  {/* <i className="icon-arrow-right"></i> */}
                </button>
                <div className="contact-result"></div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label>
                    Data Type <span style={{ color: "red" }}>*</span>
                  </label>

                  {DataTypes.map((item, index) => (
                    <div key={index} className="form-check">
                      <input
                        id={`data-type-${index}`}
                        style={{ marginTop: "0.3rem" }}
                        type="radio"
                        className="form-check-input"
                        defaultChecked={item === "Structured Data"}
                        value={item}
                        name="data_type"
                        {...register("data_type")}
                      />

                      <label
                        htmlFor={`data-type-${index}`}
                        className="form-check-label"
                        style={{ fontWeight: 500, fontSize: "12px" }}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label>
                  File Upload is required
                  <span style={{ color: "red" }}>*</span>
                </label>
                <label
                  htmlFor="contained-button-file"
                  id="button-upload"
                  className="btn btn__secondary btn__rounded btn__block  btn__xhight"
                >
                  <input
                    type="file"
                    id="contained-button-file"
                    hidden
                    accept={acceptedFileTypes}
                    {...register("uploaded_file", {
                      required: "File Upload is required.",
                    })}
                  />
                  Choose file
                </label>
                {errors.uploaded_file && !submitted && (
                  <p className="errorMsg">{errors.uploaded_file.message}</p>
                )}
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6"></div>
              <div
                className="col-sm-6 col-md-6 col-lg-6"
                style={{ margin: "auto" }}
              >
                {fileNameSelected !== undefined && fileNameSelected.length > 0
                  ? "Selected File : " + fileNameSelected[0].name
                  : []}
              </div>
              {isAIEnabled && (
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Box
                    sx={{
                      backgroundColor: "#FFF8E1",
                      border: "1px solid #FFECB3",
                      borderRadius: "6px",
                      padding: "12px",
                      display: "flex",
                      flexDirection: "column",
                      gap: 1.5,
                      color: "#795548",
                      fontSize: "0.875rem",
                      lineHeight: 1.4,
                      marginBottom: 1.5,
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: 600,
                          wordBreak: "break-word",
                          mb: 0.75,
                        }}
                      >
                        Quantitative Lab Report (OCR based) is best optimized
                        for:
                      </Typography>
                      <Box
                        component="ul"
                        sx={{
                          m: 0,
                          pl: 2.25,
                          fontSize: "0.8rem",
                          "& li": { mb: 0.35 },
                        }}
                      >
                        <Typography component="li" sx={{ fontSize: "0.8rem" }}>
                          Clinical pathology (biochemistry, hematology)
                        </Typography>
                        <Typography component="li" sx={{ fontSize: "0.8rem" }}>
                          Endocrinology (hormone panels)
                        </Typography>
                        <Typography component="li" sx={{ fontSize: "0.8rem" }}>
                          Structured immunology reports
                        </Typography>
                      </Box>
                      <Typography sx={{ fontSize: "0.8rem", mt: 1 }}>
                        For other kinds of reports, please choose Diagnostic
                        Report.
                      </Typography>
                    </Box>
                    {isDiagUnstructured && (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", lg: "row" },
                          alignItems: { xs: "flex-start", lg: "center" },
                          justifyContent: "space-between",
                          gap: 1,
                          pt: 1.5,
                          borderTop: "1px solid #FFECB3",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            flex: 1,
                            minWidth: 0,
                          }}
                        >
                          <span style={{ fontSize: "12px", flexShrink: 0 }}>
                            ⚠️
                          </span>
                          <Typography
                            component="span"
                            sx={{
                              flex: 1,
                              wordBreak: "break-word",
                              fontSize: "0.8rem",
                            }}
                          >
                            Quantitative Lab Report PDFs over 3–4 pages may
                            cause OCR errors or missing values.
                          </Typography>
                        </Box>
                        {acceptedFileTypes === ".pdf" && pdfPreviewUrl && (
                          <Typography
                            component="span"
                            onClick={() => setIsPreviewModalOpen(true)}
                            sx={{
                              color: "#0E3F66",
                              textDecoration: "underline",
                              cursor: "pointer",
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                              mt: { xs: 0.5, lg: 0 },
                              ml: { xs: 0, lg: 1.5 },
                              flexShrink: 0,
                            }}
                          >
                            Preview
                          </Typography>
                        )}
                      </Box>
                    )}
                  </Box>
                </div>
              )}
              <Modal
                open={isPreviewModalOpen}
                onClose={() => setIsPreviewModalOpen(false)}
                aria-labelledby="upload-file-modal-pdf-preview"
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "95%", md: "85%" },
                    height: { xs: "75vh", md: "85vh" },
                    bgcolor: "background.paper",
                    borderRadius: "10px",
                    boxShadow: 24,
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography
                      id="upload-file-modal-pdf-preview"
                      variant="subtitle1"
                      sx={{ fontWeight: 600, color: "#0E3F66" }}
                    >
                      PDF Preview
                    </Typography>
                    <Typography
                      component="span"
                      onClick={() => setIsPreviewModalOpen(false)}
                      sx={{
                        color: "#0E3F66",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontWeight: 600,
                      }}
                    >
                      Close
                    </Typography>
                  </Box>
                  {pdfPreviewUrl && (
                    <iframe
                      src={pdfPreviewUrl}
                      title="Uploaded PDF Preview Modal"
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "1px solid #E5E7EB",
                        borderRadius: "8px",
                      }}
                    />
                  )}
                </Box>
              </Modal>

              <div className="col-sm-10 col-md-10 col-lg-10">
                <button
                  type="submit"
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                >
                  <span>Add Health Data</span>{" "}
                  {/* <i className="icon-arrow-right"></i> */}
                </button>
                <div className="contact-result"></div>
              </div>
              <div
                className="col-sm-2 col-md-2 col-lg-2"
                style={{ margin: "auto" }}
              >
                <StyledTooltip
                  arrow
                  placement="right"
                  title={
                    <Box
                      sx={{
                        backgroundColor: "#21cdc0",
                        p: 2,
                        borderRadius: "8px",
                        boxShadow: "0px 0px 0px white",
                        border: "none",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "bold", color: "#fff", mb: 1 }}
                      >
                        Excel Upload Instructions
                      </Typography>
                      <List sx={{ color: "#fff", pl: 2 }}>
                        <ListItem>
                          Columns should be as it is in the template
                        </ListItem>
                        <ListItem>
                          Zip the master and details files along with
                          attachments (if any), then upload the zip file
                        </ListItem>
                        <ListItem>
                          The master file must contain one row with the
                          patient's details as per the template
                        </ListItem>
                        <ListItem>
                          The details file can have multiple rows, maintaining
                          consistency throughout
                        </ListItem>
                      </List>
                    </Box>
                  }
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      cursor: "pointer",
                    }}
                  >
                    <InfoOutlinedIcon sx={{ color: "#0E3F66", fontSize: 20 }} />
                    <Typography
                      variant="body2"
                      sx={{ color: "#0E3F66", fontWeight: "bold" }}
                    >
                      HELP
                    </Typography>
                  </Box>
                </StyledTooltip>
              </div>
              <div className="col-12">
                <small className="form-text text-muted mt-2">
                  <span style={{ color: "red" }}>*</span> Only{" "}
                  <strong>{acceptedFileTypes}</strong> files are allowed for
                  upload.
                </small>
              </div>
            </div>
          </form>
          {/* {abhaId && ( */}
          <LinkingForUploadRepAppointmentPage
            refresh={refresh}
            setAiResponse={setAiResponse}
            setSelectedPatient={setSelectedPatient}
            patientId={patientId}
          />
          {/* )} */}
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default UploadFileForModal;
